import React, { FunctionComponent, memo, useContext } from 'react';
import { VariantIdsOnPageContext } from '../../react/VariantIdsOnPageContext';
import FinanceCalculatorWidget from './FinanceCalculatorWidget';
import { ICarDetails } from '../../../../../common/model/ICarDetails';
import { useFinCalcConfigurator } from '../../react/useFinCalcConfigurator';
import { IFinCalcSpcInitConfig } from '../../react/useGetFinCalcSpcInitConfig';
import Loader from '../presentation/Loader';
import InitErrorMessage from '../presentation/error/InitErrorMessage';
import useCustomerStorage from '../../hooks/useCustomerStorage';

export interface IFinanceCalculatorConfiguratorWidget {
  carConfiguration: ICarDetails | IFinCalcSpcInitConfig;
  toggleModal: (shouldOpen: boolean) => void;
}

const FinanceCalculatorConfiguratorWidget: FunctionComponent<IFinanceCalculatorConfiguratorWidget> = memo(props => {
  const { postInitialization, isDealLoading, financeError } = useFinCalcConfigurator(props);
  const { customerStorage } = useCustomerStorage();

  if (isDealLoading) {
    return <Loader />;
  }

  if (financeError) {
    return <InitErrorMessage error={financeError} message={'Finance Calculator widget initialization failed'} />;
  }

  const { variantIds } = useContext(VariantIdsOnPageContext);
  const postcode = customerStorage.getCustomerData().postcode;
  const { carConfiguration } = props;

  const detailsAggregated = (carConfiguration as ICarDetails).detailsAggregated.toLowerCase();
  const additionalVariantIds = variantIds.filter(variantId => variantId.toLowerCase() !== detailsAggregated);

  return <FinanceCalculatorWidget {...{ carConfiguration, postInitialization, additionalVariantIds, postcode }} />;
});

export default FinanceCalculatorConfiguratorWidget;
